import { render } from "./BoqListQuotation.vue?vue&type=template&id=66e284ff&scoped=true"
import script from "./BoqListQuotation.vue?vue&type=script&lang=js"
export * from "./BoqListQuotation.vue?vue&type=script&lang=js"

import "./BoqListQuotation.vue?vue&type=style&index=0&id=66e284ff&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e284ff"]])

export default __exports__